import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RoutesPaths } from "../../Router/constant";
import {
  selectCompanyDashboard,
  selectedCompanyStepAction,
  selectPendingCompany,
} from "../../actions/company";
import { useNavigate } from "react-router";
import { showCompanyAddAction } from "../../actions/auth";
import AddModal from "../../components/addBussiness/AddModal";
import ContentLoader from "react-content-loader";
import { denyPendingInviteAction, getpendingInviteAction, removePromoterInviteModalAction, skipPromoterInviteModal } from "../../actions/promoters";
import { getPositionName } from "../InvitesIndividualGlobal/IndividualInviteTableGlobal";
import DenyPendingInvite from "../InvitesIndividualGlobal/DenyPendingInvite";
import GetToaster from "../../components/header/getToaster";

export default function CompanySettings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { company, pendingCompany, validateNotDefaultCompany } = useSelector(
    (state) => state.company
  );
  const { toastMessage } = useSelector(state => state.message)
  const { user } = useSelector(state => state.user)

  const changeCompany = (companyId) => {
    dispatch(selectCompanyDashboard(companyId));
    navigate(RoutesPaths.DASHBOARD, { replace: true })
  };

  const { loadReferral } = useSelector((state) => state.referralInvites);
  const { pendingInvites } = useSelector((state) => state.promoters);

  const [record, setRecord] = useState(5);
  const [removeModalShow, setRemoveModalShow] = useState(false);
  const [actionData, setActionData] = useState(null);

  const handleRemove = (item) => {
    setRemoveModalShow(true);
    setActionData(item);
  };

  const onLoad = () => {
    setRecord(record + 5);
  };

  useEffect(() => {
    dispatch(getpendingInviteAction());
  }, [dispatch]);

  const removeModalCloseConfirm = async () => {
    if (actionData.id) {
      await dispatch(denyPendingInviteAction(actionData?.company?._id, actionData.id));
    }
    setRemoveModalShow(false);
    inviteCancelTrigger()
  };

  const handleAcknowledge = (item, indexValue) => {
    dispatch(removePromoterInviteModalAction(item?.token, indexValue))
  }

  const inviteCancelTrigger = () => {
    if (pendingInvites.length > 0) {
      dispatch(skipPromoterInviteModal(pendingInvites));
    }
  };
  const isAnyModalOpen = !!document.querySelector('.modal.show');

  return (
    <>
      <div className="companyHeaderImage">
        <img
          onClick={() => navigate(RoutesPaths.DASHBOARD, { replace: true })}
          src="assets/img/inproved-logo.svg"
          className="inproved-logo cursorPointer"
          alt="kimbocorp"
        />
      </div>
      <div className="container-fluid companySelectContainer">
        {!isAnyModalOpen && toastMessage && <GetToaster />}
        <div className="row companySelectCard">
          <div className="col-md-8">
            <div className="companySelectHeader">
              {/* <h6 className="m-0">All Companies</h6> */}
              <p className="m-0">
                View, manage, and switch between your companies easily.
              </p>
            </div>

            {/* User account */}
            <div className="row">
              <div className="col-md-12 selectedCompanycard">
                <div className="row companyHeaderSec userCompanyheaderSec">
                  <div className="col-7 col-md-5">User account</div>
                  <div className="col-5 col-md-4 statusHeader">Status</div>
                  <div className="col-md-3 hedaerAction mobileHide">Action</div>
                </div>

                {!company || company.length === 0 ? (
                  <div className="row selectedAddedCompanySec">
                    <div className="col-md-12">
                      <ContentLoader width="100%" height={40}>
                        <rect
                          x="0"
                          y="0"
                          rx="10"
                          ry="10"
                          width="100%"
                          height="40"
                        />
                      </ContentLoader>
                    </div>
                  </div>
                ) : (
                  company.map(
                    (info, index) =>
                      info?.isDefault && (
                        <div
                          className="row selectedAddedCompanySec"
                          key={index}
                        >
                          <div className="col-7 col-md-5 userAccountName">
                            <div className="companyUserIcon">
                              {" "}
                              {info.companyName
                                ? info.companyName.charAt(0).toUpperCase()
                                : "U"}
                            </div>
                            <h6 className="m-0">{info.companyName}</h6>
                          </div>
                          <div className="col-5 col-md-4 userBadgeOuterSec">
                            <div className="userBadgeSec userBadgeActiveSec">
                              <div className="userAccountdot userActiveDot"></div>
                              <p className="m-0">Active</p>
                            </div>
                          </div>
                          <div className="col-12 col-md-3 actionSelectButton">
                            <button
                              className="userSelectButton"
                              onClick={() => changeCompany(info.id)}
                            >
                              Open dashboard
                            </button>
                          </div>
                        </div>
                      )
                  )
                )}

                {/* Holding companies */}
                {company && company.length > 0 && validateNotDefaultCompany && (
                  <div className="row companyHeaderSec">
                    <div className="col-7 col-md-5">Holding companies</div>
                    <div className="col-5 col-md-4"></div>
                    <div className="col-md-3 hedaerAction mobileHide"></div>
                  </div>
                )}

                {!company || company.length === 0
                  ? [...Array(5)].map((_, index) => (
                    <div className="row selectedAddedCompanySec" key={index}>
                      <div className="col-md-12">
                        <ContentLoader width="100%" height={42}>
                          <rect
                            x="0"
                            y="0"
                            rx="10"
                            ry="10"
                            width="100%"
                            height="42"
                          />
                        </ContentLoader>
                      </div>
                    </div>
                  ))
                  : company.map(
                    (info, index) =>
                      !info?.isDefault && (
                        <div
                          className="row selectedAddedCompanySec"
                          key={index}
                        >
                          <div className="col-7 col-md-5 userAccountName">
                            <div className="companyUserIcon">
                              {" "}
                              {info.companyName
                                ? info.companyName.charAt(0).toUpperCase()
                                : "U"}
                            </div>
                            <div>
                              <h6 className="m-0">{info.companyName}</h6>
                              <p className="m-0">
                                {info?.companyRoleUser?.join(" | ") || ""}
                              </p>
                            </div>
                          </div>
                          <div className="col-5 col-md-4 userBadgeOuterSec">
                            <div className="userBadgeSec userBadgeActiveSec">
                              <div className="userAccountdot userActiveDot"></div>
                              <p className="m-0">{user?.id === info?.user ? "Active" : "Invite accepted"}</p>
                            </div>
                          </div>
                          <div className="col-12 col-md-3 actionSelectButton">
                            <button
                              className="userSelectButton"
                              onClick={() => changeCompany(info.id)}
                            >
                              Open dashboard
                            </button>
                          </div>
                        </div>
                      )
                  )}

                {!loadReferral ? (
                  pendingInvites?.length > 0 &&
                  pendingInvites?.map((item, index) => (
                    <div key={index} className="row selectedAddedCompanySec" >
                      <div className="col-7 col-md-5 userAccountName">
                        <div className="companyUserIcon">{item?.company?.companyName
                          ? item?.company?.companyName.charAt(0).toUpperCase()
                          : ""}</div>                        <div>
                          <h6 className="m-0">{item.company?.companyName}</h6>
                          <p className="m-0">{getPositionName(item.type)}</p>
                        </div>
                      </div>
                      <div className="col-5 col-md-4 userBadgeOuterSec">
                        <div className="userBadgeSec userBadgePendingSec">
                          <div className="userAccountdot userPendingDot"></div>
                          <p className="m-0">{item.is_delete_requested ? "Invite accepted" : "Invite pending"}</p>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 actionSelectButton">
                        <button onClick={() => handleRemove(item)} className="userSelectButton userSelectDenyButton">
                          Deny
                        </button>
                        <button onClick={() => handleAcknowledge(item, index)} className="userSelectButton">Accept</button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="table-responsive p-3">
                    {[80, 60].map((item, index) => (
                      <ContentLoader key={index} width={item + "%"} height={15}>
                        <rect rx="5" ry="5" width={item + "%"} height="15" />
                      </ContentLoader>
                    ))}
                  </div>
                )
                }
                {/* Pending companies */}
                {pendingCompany && pendingCompany.length > 0 &&
                  <>
                    <div className="row companyHeaderSec">
                      <div className="col-7 col-md-5">Pending companies</div>
                      <div className="col-5 col-md-4"></div>
                      <div className="col-md-3 hedaerAction mobileHide"></div>
                    </div>

                    {pendingCompany && pendingCompany.length > 0
                      ? pendingCompany.map((info, index) => (
                        <div className="row selectedAddedCompanySec" key={index}>
                          <div className="col-7 col-md-5 userAccountName">
                            <div className="companyUserIcon">
                              {info.companyName
                                ? info.companyName.charAt(0).toUpperCase()
                                : "U"}
                            </div>
                            <div>
                              <h6 className="m-0">{info.companyName}</h6>
                              <p className="m-0">
                                {info?.companyRoleUser?.join(" | ") || ""}
                              </p>
                            </div>
                          </div>
                          <div className="col-5 col-md-4 userBadgeOuterSec">
                            <div className="userBadgeSec userBadgePendingSec">
                              <div className="userAccountdot userPendingDot"></div>
                              <p className="m-0">Setup pending</p>
                            </div>
                          </div>
                          <div className="col-12 col-md-3 actionSelectButton">
                            <button
                              onClick={() => {
                                navigate(`${RoutesPaths.ADD_COMPANY}?id=${info?.id}`);
                                dispatch(selectPendingCompany(info));
                                dispatch(selectedCompanyStepAction(1))
                              }}
                              className="userSelectButton"
                            >
                              Resume Setup
                            </button>
                          </div>
                        </div>
                      ))
                      : // Show 5 skeleton loaders when loading or no data
                      [...Array(5)].map((_, index) => (
                        <div className="row selectedAddedCompanySec" key={index}>
                          <div className="col-md-12">
                            <ContentLoader width="100%" height={42}>
                              <rect
                                x="0"
                                y="0"
                                rx="10"
                                ry="10"
                                width="100%"
                                height="42"
                              />
                            </ContentLoader>
                          </div>
                        </div>
                      ))}
                  </>
                }

                <div className="row">
                  <div className="col-md-12 addNewBusinessBtnOuter">
                    <button
                      className="addNewBusinessBtn"
                      onClick={() => {
                        navigate(RoutesPaths.ADD_COMPANY);
                        dispatch(selectPendingCompany(null));
                        dispatch(selectedCompanyStepAction(1))
                      }}
                    >
                      <img src="/assets/img/plus-circle.svg" />
                      Add new business
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      <DenyPendingInvite
        removeModalShow={removeModalShow}
        removeModalClose={() => setRemoveModalShow(false)}
        removeModalCloseConfirm={removeModalCloseConfirm}
        actionData={actionData}
      />
    </>
  );
}
